import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getEquipoAnexos = async (codigoEquipo) => {
  try {
    const userInfo = fetchUser();

    const { data } = await Axios.get(
      `/equipoanexo?empresa=${userInfo.empresa}&codigoEquipo=${codigoEquipo}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const upsertEquipoAnexo = async (anexoData) => {
  try {
    const userInfo = fetchUser();

    const { data } = await Axios.post(
      '/equipoanexo', { ...anexoData, empresa: userInfo.empresa }
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteEquipoAnexo = (id) => Axios.delete(`/equipoanexo/${id}`);
